import { render, staticRenderFns } from "./AssignEmployeeToPrimaryPositionDialog.vue?vue&type=template&id=73ff8ce8&scoped=true"
import script from "./AssignEmployeeToPrimaryPositionDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AssignEmployeeToPrimaryPositionDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AssignEmployeeToPrimaryPositionDialog.vue?vue&type=style&index=0&id=73ff8ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ff8ce8",
  null
  
)

export default component.exports